<script>
import Multiselect from 'vue-multiselect'
import { permsMethods, groupsMethods, appSectionsMethods } from '@state/helpers'

import _ from 'lodash'

export default {
    name: 'UsersUpdateForm',
    components: { Multiselect },
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        onphotosubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            },
    },
    data() {
        return {
            photo_file : '',
            photoUrl: require('@assets/images/users/avatar-clear.png'),
            loadingPhotoUpdate: false,
            permsOptions: [],
            groupsOptions: [],
            appSectionsOptions: [],
            permsOptionsCache: [],
            groupsOptionsCache: [],
            appSectionsOptionsCache: [],
            loadingGroupsOptions: false,
            loadingPermsOptions: false,
            loadingAppSectionsOptions: false,
            permsOptionsMounted: false,
            groupsOptionsMounted: false,
            appSectionsOptionsMounted: false
        }
    },
    mounted(){
        this.populateAppPermsOptions()
        this.populateGroupsOptions()
        this.populateAppSectionsOptions()
        if (this.form.user_info && this.form.user_info.photo){
            this.photoUrl = this.form.user_info.photo
        }
    },
    methods: {
        ...permsMethods,
        ...groupsMethods,
        ...appSectionsMethods,
        populateAppPermsOptions(searchQuery){
            // Filters only AppPerms type=2,
            // Section perms corresponds to sections
            let context = this
            context.loadingPermsOptions = true
            let reqParams = context.$select_params(searchQuery)
            reqParams = `${reqParams}${!reqParams ? '?' : '&'}permission_type=2`
            const promise = context.fetchPerms(reqParams)
            return promise.then(data => {
                let listOptions = []
                data.results.forEach(opt => {
                    listOptions.push({
                        'url': opt.permission.url,
                        'name': opt.permission.name
                    })
                });
                context.permsOptions = listOptions
                context.loadingPermsOptions = false
                context.permsOptionsMounted = true
            }).catch(error => {
                context.$axios_error_noty(error, context)
                context.loadingPermsOptions = false
                context.permsOptionsMounted = true
            })
        },
        populateGroupsOptions(searchQuery){
            let context = this
            context.loadingGroupsOptions = true
            let reqParams = context.$select_params(searchQuery)
            const promise = context.fetchGroups(reqParams)
            return promise.then(data => {
                let listOptions = []
                data.results.forEach(opt => {
                    listOptions.push({
                        'url': opt.url,
                        'name': opt.name
                    })
                });
                context.groupsOptions = listOptions
                context.loadingGroupsOptions = false
                context.groupsOptionsMounted = true
            }).catch(error => {
                context.$axios_error_noty(error, context)
                context.loadingGroupsOptions = false
                context.groupsOptionsMounted = true
            })
        },
        populateAppSectionsOptions(searchQuery){
            let context = this
            context.loadingAppSectionsOptions = true
            let reqParams = context.$select_params(searchQuery)
            reqParams = `${reqParams}${!reqParams ? '?' : '&'}admin_required=false&app_permission__isnull=false`
            const promise = context.fetchAppSections(reqParams)
            return promise.then(data => {
                let listOptions = []
                data.results.forEach(opt => {
                    let parentTreeName = ''
                    if (opt.parent_tree.length - 1){
                        for (let i = 0; i < opt.parent_tree.length; i++) {
                            if(i !== (opt.parent_tree.length - 1)){
                                const el = opt.parent_tree[i];
                                parentTreeName = parentTreeName.concat(`${el.name} > `)
                            }
                        }
                    }
                    parentTreeName = parentTreeName.concat(opt.name)
                    listOptions.push({
                        'url': opt.url,
                        'name': opt.name,
                        parentTreeName
                    })
                });
                context.appSectionsOptions = listOptions
                context.loadingAppSectionsOptions = false
                context.appSectionsOptionsMounted = true
            }).catch(error => {
                context.$axios_error_noty(error, context)
                context.loadingAppSectionsOptions = false
                context.appSectionsOptionsMounted = true
            })
        },
        asyncFindPerms: _.debounce(function (searchQuery) {
            this.populateAppPermsOptions(searchQuery)
        }, 600),

        asyncFindGroups: _.debounce(function (searchQuery) {
            this.populateGroupsOptions(searchQuery)
        }, 600),
        asyncFindAppSections: _.debounce(function (searchQuery) {
            this.populateAppSectionsOptions(searchQuery)
        }, 600),
        labelOfAppPerms(opt){
            let permsOptionsFounded = this.permsOptions.find(x => x.url === opt)
            if (!permsOptionsFounded){
                let cacheFounded = this.permsOptionsCache.find(x => x.url === opt)
                return  cacheFounded ? cacheFounded.name : this.permsOptionsMounted ? `Not found in options: ${opt}`: ''
            }else{
                if (this.form.user_permissions.find(x => x === opt)){
                    if (!this.permsOptionsCache.find(x => x.url === opt)){
                        this.permsOptionsCache.push(permsOptionsFounded)
                    }
                }
                return permsOptionsFounded.name
            }
        },
        labelOfGroups(opt){
            let groupsOptionsFounded = this.groupsOptions.find(x => x.url === opt)
            if (!groupsOptionsFounded){
                let cacheFounded = this.groupsOptionsCache.find(x => x.url === opt)
                return  cacheFounded ? cacheFounded.name : this.groupsOptionsMounted ? `Not found in options: ${opt}`: ''
            }else{
                if (this.form.groups.find(x => x === opt)){
                    if (!this.groupsOptionsCache.find(x => x.url === opt)){
                        this.groupsOptionsCache.push(groupsOptionsFounded)
                    }
                }
                return groupsOptionsFounded.name
            }
        },
        labelOfAppSections(opt){
            let appSectionsOptionsFounded = this.appSectionsOptions.find(x => x.url === opt)
            if (!appSectionsOptionsFounded){
                let cacheFounded = this.appSectionsOptionsCache.find(x => x.url === opt)
                return  cacheFounded ? cacheFounded.parentTreeName : this.appSectionsOptionsMounted ? `Not found in options: ${opt}`: ''
            }else{
                if (this.form.groups.find(x => x === opt)){
                    if (!this.appSectionsOptionsCache.find(x => x.url === opt)){
                        this.appSectionsOptionsCache.push(appSectionsOptionsFounded)
                    }
                }
                return appSectionsOptionsFounded.parentTreeName
            }
        },
        openImgInput(){
            document.getElementById("id_photo").click()
        },
        imageChanged(){
            let context = this
            context.loadingPhotoUpdate = true
            context.photo_file = context.$refs.photo_file.files[0];
            let formData = new FormData()
            formData.append('photo', context.photo_file)
            context.onphotosubmit(formData).then(data=>{
                context.photoUrl = data.user_info.photo
                context.loadingPhotoUpdate = false
            }).catch(() => {
                context.loadingPhotoUpdate = false
            })
        },
    }
}
</script>
<template>
    <div>
        <b-row>
        </b-row>
        <b-form  id="form" @submit="onformsubmit" >
            <form-wrapper :validator="validator ">
                    <b-row>
                        <b-col sm="12" md="5">
                            <div>
                                <form-summary/>
                            </div>
                            <div class="text-center">
                            <div
                                id="image_avatar"
                                class="user-image"
                                :style="{ backgroundImage: `url(${photoUrl})` }"
                                v-on="!loadingPhotoUpdate ? { click: openImgInput } : {}"
                                >
                                <div v-if="!loadingPhotoUpdate" class="inner-image" >Change<br><i class="fe-camera text-white"></i></div>
                                <div v-if="loadingPhotoUpdate" class="loading-inner-image" >
                                    Changing <br>
                                    <b-spinner
                                    v-if="loadingPhotoUpdate"
                                    small
                                    label="Spinning"
                                    variant="light"
                                    >
                                    </b-spinner>
                                </div>
                            </div>
                            <input
                                id="id_photo"
                                ref="photo_file"
                                type="file"
                                style="display: none;"
                                accept="image/jpeg,image/gif,image/png,image/bmp,image/jpg"
                                @change="imageChanged"
                            />
                            <div><b>Avatar</b></div>
                            </div>
                            <form-group name="username" label="Username">
                                <b-form-input
                                    v-model="form.username"
                                    slot-scope="{ attrs, listeners }"
                                    v-bind="attrs"
                                    v-on="listeners"
                                />
                            </form-group>
                            <form-group name="first_name" label="First name">
                                <b-form-input
                                    v-model="form.first_name"
                                    slot-scope="{ attrs, listeners }"
                                    v-bind="attrs"
                                    v-on="listeners"
                                />
                            </form-group>
                            <form-group name="last_name" label="Last name">
                                <b-form-input
                                    v-model="form.last_name"
                                    slot-scope="{ attrs, listeners }"
                                    v-bind="attrs"
                                    v-on="listeners"
                                />
                            </form-group>
                            <form-group name="email" label="Email">
                                <b-form-input
                                    v-model="form.email"
                                    slot-scope="{ attrs, listeners }"
                                    v-bind="attrs"
                                    v-on="listeners"
                                />
                            </form-group>
                            <!-- <b-form-checkbox
                                id="isstaff-check"
                                v-model="form.is_staff"
                                name="isstaff-check"
                                value="true"
                                unchecked-value="false"
                            >
                                Is staff ?
                            </b-form-checkbox> -->
                            <b-form-checkbox
                                v-model="form.is_superuser"
                                value="true"
                                unchecked-value="false"
                            >
                                Is superuser ?
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="form.is_active"
                                value="true"
                                unchecked-value="false"
                            >
                                Is active ?
                            </b-form-checkbox>
                        </b-col>
                        <b-col sm="12" md="7">
                            <form-group name="perms-select" label="User permissions">
                                <Multiselect
                                    id="perms-select"
                                    v-model="form.user_permissions"
                                    :multiple="true"
                                    :options="permsOptions.map(x => x.url)"
                                    :custom-label="opt => labelOfAppPerms(opt)"
                                    :loading="loadingPermsOptions"
                                    :internal-search="false"
                                    @search-change="asyncFindPerms">
                                </Multiselect>
                            </form-group>
                            <form-group name="groups-select" label="User groups">
                                <Multiselect
                                    id="groups-select"
                                    v-model="form.groups"
                                    :multiple="true"
                                    :options="groupsOptions.map(x => x.url)"
                                    :custom-label="opt => labelOfGroups(opt)"
                                    :loading="loadingGroupsOptions"
                                    :internal-search="false"
                                    @search-change="asyncFindGroups">
                                </Multiselect>
                            </form-group>
                            <form-group name="app-sections-select" label="Sections can access">
                                <Multiselect
                                    id="app-sections-select"
                                    v-model="form.app_sections_users"
                                    :multiple="true"
                                    :options="appSectionsOptions.map(x => x.url)"
                                    :custom-label="opt => labelOfAppSections(opt)"
                                    :loading="loadingAppSectionsOptions"
                                    :internal-search="false"
                                    @search-change="asyncFindAppSections">
                                </Multiselect>
                                <b-form-text>
                                    <b>Note:</b> <br>
                                    <ul>
                                        <li>Superusers can access to all sections</li>
                                        <li>Sections that require superuser or do not have assigned permission will not be assignable</li>
                                    </ul>
                                </b-form-text>
                            </form-group>
                            <!-- <router-link :to="{ name: 'platform-settings-users-subscriptions', params: { userUrl: form.url } }">
                                <b-button variant="primary">Manage user subscriptions</b-button>
                            </router-link> -->
                        </b-col>
                    </b-row>
            </form-wrapper>
        </b-form>
    </div>
</template>

<style lang="scss">
    .user-image {
        display: inline-block;
        z-index: 5;
        height: 128px;
        width: 128px;
        box-shadow: 0px 0px 2px 2px rgba(255,255,255,0.3);
        border-radius: 50%;
        background-size: cover;
        background-position: top center;
        overflow: hidden;
        /*background-image: url('');*/
    }
    .user-image:hover .inner-image {
        background-color: rgb(0,0,0,0.4);
        display: block;
    }
    .user-image .inner-image {
        display: none;
        cursor: pointer;
        color: white;
        width: 100%;
        height: 100%;
        font-size: 15px;
        text-align: center;
        padding-top: 46px;
        font-weight: bolder;
        line-height: 1.2;
    }
    .user-image .inner-image i {
        font-size: 20px;
    }

    .user-image .loading-inner-image {
        background-color: rgb(0,0,0,0.4);
        cursor: not-allowed;
        color: white;
        width: 100%;
        height: 100%;
        font-size: 15px;
        text-align: center;
        padding-top: 46px;
        font-weight: bolder;
        line-height: 1.2;
    }
    .user-image .loading-inner-image i {
        font-size: 20px;
    }

</style>